import googleIcon from "assets/icons/google-icon.svg";
import yandexIcon from "assets/icons/yandex.png";

import help from "assets/icons/help.svg";
import { gapi } from "gapi-script";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import PinCode from "hooks/PinCode/PinCode";
import ButtonLoader from "hooks/UseLoading/ButtonLoader";
import useLoading from "hooks/UseLoading/UseLoading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import eye from "assets/icons/eye.png";
import hidden from "assets/icons/hidden.png";
import {
  ChangePin,
  SendDevice,
  getEmailDatacor,
  getUserInfo,
  login,
  logintrash,
  postToMail,
} from "service/AuthService";
import {
  checkPinCode,
} from "service/AuthService";
import { getImage } from "service/BackgroundService";

import { changePinCode, postMail, setUser } from "store/slices/UserSlice";
import Notification from "utils/Notifications";
import tokenDecode from "utils/decode";
import { ScaleLoader } from "react-spinners";
import rostok from "assets/icons/rostok.png";
import { Button } from "components";
import RegisterForTest from "../RegisterForm/RegisterForTest";
import RecoverPasswordForm from "../RecoverPasswordForm/RecoverPasswordForm";
import RecoverPinForm from "../RecoverPinForm/RecoverPinForm";

import styles from "./LoginForm.module.scss";



import { YandexLogin } from 'react-yandex-login';
 
const clientID = '187efcae240d4cadae5fcd470868203b';

function LoginForm() {
  //UseState
  const [loader, setLoader] = useState(false);
  const [loginMail, setLoginMail] = useState(false);
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [recoverPin, setRecoverPin] = useState(false);

  const [password, setPassword] = useState("");
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [userId, setUserId] = useState();
  const [email, setEmail] = useState("");
  const [emailCor, setEmailCor] = useState("");
  const [device, setDevice] = useState("");
  //TEST GOOGLE

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);

  //Dispatch & Navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let data;
  //МОДАЛКА
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);

  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.log("CHU");
      // Handle the case when the socket is not open
    }
  };

  //Notifications
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //UseSelector
  const user = useSelector((state) => state.user);

  const { loading, withLoading } = useLoading(false);
  //Functions
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (email === "") {
      setNotify({
        isOpen: true,
        message: "Введите ИНН!",
        type: "warning",
        sound: "warning",
      });
    } else if (password === "") {
      setNotify({
        isOpen: true,
        message: "Введите пароль!",
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        await withLoading(async () => {
          let response = await login(email, password);
          localStorage.setItem("token", response.data.access);
          const userId = tokenDecode(response.data.refresh);

          let userResponse = await getUserInfo(userId);
          const data = { ...userResponse.data, token: response.data.access };

          //урезал код
          setUserPinCode(data.pin);
          setDataInfo(data)
          setOpenModal(true);
          setUserId(userId);
        });
      } catch (error) {
        setNotify({
          isOpen: true,
          message:
            error.response?.data?.detail ||
            `Пароль ${error.response.data.password}`,
          type: "error",
          sound: "error",
        });
      }
    }
  };

  const signIn = async (event) => {
    event.preventDefault();
    const _auth0k = (googleUser) => {
      const emails = googleUser.getBasicProfile().getEmail();
      var auth2 = gapi.auth2.getAuthInstance();

      // auth2.signOut().then(function () {});

      async function f() {
        try {
          let emailtrash = "free";
          let passwordtrash = "free";
          let responsed = await logintrash(emailtrash, passwordtrash);
          localStorage.setItem("token", responsed.data.access);
          const userIdd = tokenDecode(responsed.data.refresh);
          let userResponsed = await getUserInfo(userIdd);
          const datas = { ...userResponsed.data, token: responsed.data.access };
          setUserId(datas.user);
          setUserPinCode(datas.pin);
          dispatch(setUser(datas));
          try {
            let responses = await getEmailDatacor(emails);

            emailtrash = responses.data.username;
            passwordtrash = responses.data.password;
          } catch (error) {
            setNotify({
              isOpen: true,
              message:
                error.response.data.detail ||
                `Пароль ${error.response.data.password}`,
              type: "error",
              sound: "error",
            });
            emailtrash = "lol";
            passwordtrash = "lol";
          }
          // localStorage.removeItem("token");
          localStorage.removeItem("task");
          localStorage.removeItem("user");
          let response = await logintrash(emailtrash, passwordtrash);
          localStorage.setItem("token", response.data.access);
          const userId = tokenDecode(response.data.refresh);
          let userResponse = await getUserInfo(userId);
          const data = { ...userResponse.data, token: response.data.access };

          //Урезал код
          setDataInfo(data)
          setUserPinCode(data.pin);
          setOpenModal(true);
          setUserId(userId);

          // navigate(`/home/`);
        } catch (error) {
          setNotify({
            isOpen: true,
            message:
              error.response.data.detail ||
              `Пароль ${error.response.data.password}`,
            type: "error",
            sound: "error",
          });
        }
      }
      f();
    };

    const _authErr = () => {
      setNotify({
        isOpen: true,
        message: "Ошибка авторизации",
        type: "error",
        sound: "error",
      });
    };
    const GOOGLE_AUTH = gapi.auth2.getAuthInstance();
    GOOGLE_AUTH.signIn({
      scope: "profile email",
    }).then(_auth0k, _authErr);
  };
  useEffect(() => {
    function start() {
      gapi.auth2
        .init({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        })
        .then(() => console.log("CHU"));
    }
    gapi.load("client:auth2", start);
  });

 const pinLogIn = async () => {
  localStorage.setItem("mute", false);

  if (String(pinCode).length === 4) {
    setLoader(true);
 
    try {
      const response = await checkPinCode(pinCode, userId); // отправляем на сервер

      if (response.data.success) {
        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
          sound: "enter"
        });

        const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
        socket.onopen = () => {
          socket.send(JSON.stringify({ command: "connect", user_id: userId }));
          socket.close();
        };

        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));

        setTimeout(() => {
          window.location.href = `/home/`;
        }, 1000);

      } else {
        setNotify({
          isOpen: true,
          message: "Неправильный Пин-Код",
          type: "error",
          sound: "error",
        });
      }
    } catch (error) {
      console.error("Ошибка при проверке PIN:", error);
      setNotify({
        isOpen: true,
        message: "Ошибка сервера",
        type: "error",
        sound: "error",
      });
    } finally {
      setLoader(false);
    }

  } else {
    setNotify({
      isOpen: true,
      message: "Введите 4-значный ПИН-код",
      type: "warning",
      sound: "warning",
    });
  }
};


  const createUserPin = async () => {

    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: "Пин успешно задан",
            type: "success",
            sound: "enter"
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
          sound: "enter"
        });
        // let response4 = await getTariffSubscription(datainfo);
       
        // localStorage.setItem(
        //   "subscription_title",
        //   JSON.stringify(response4.data.subscription[0].tariff.title)
        // );
        
        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));
        setTimeout(() => {

          navigate(`/home/`);
        }, 4000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
          sound: "error",
        });
      }
    }
  };

  const handleSubmitByMail = async (event) => {
    event.preventDefault();

    let response = await postToMail(emailCor);
    dispatch(
      postMail({
        email: emailCor,
      })
    );

    setNotify({
      isOpen: true,
      message: "Сообщение на почту успешно отправлено!",
      type: "success",
      sound: "success",
    });
  };
  const RecoverPin = () => {
    console.log("Recover")
    setOpenModal(false)
    setLoginMail(false)
    setRecoverPassword(false)
    setRecoverPin(true)


  };
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);


  const [userData, setUserData] = useState(undefined);
 
  const loginSuccess = (userData) => {
    console.log('User Data: ', userData);
    setUserData(userData)
  }
 
  const logoutSuccess = () => {
    setUserData(null);
  }

  return (
    <div>
      {loginMail === false ? (
        recoverPassword === false ? (
          recoverPin === false ? (
            <div>


              <h2 className={styles.login__title}>Рады видеть вас в CHU! 👋🏻</h2>
              <h4 className={styles.login__untitle}>Пожалуйста, войдите в свою учетную запись</h4>
              <label className={styles.login__title__label} htmlFor="login">
                ИНН
              </label>
              <input
                id="login"
                name="username"
                value={email}
                required="required"
                type='number'
                onChange={(e) => setEmail(e.target.value)}
                className={styles.login__input}
              />

              <div>
                <label className={styles.login__title__label} htmlFor="password">
                  Пароль
                </label>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  required="required"
                  onChange={(e) => setPassword(e.target.value)}
                  className={styles.login__input}
                />

                <div
                  src={eye}
                  type="button"
                  className={styles.show__password}
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <>
                      {" "}
                      <img src={hidden}></img>{" "}
                    </>
                  ) : (
                    <>
                      {" "}
                      <img src={eye}></img>{" "}
                    </>
                  )}
                </div>
              </div>
              <div className={styles.button__wrapper}>
                <ButtonLoader loading={loading} position={"center"}>
                  {" "}
                  <Button
                    onClick={handleSubmit}
                    className="auth__btn"
                    style={{ margin: "15px 0 0px 0" }}
                  >
                    Войти
                  </Button>

                </ButtonLoader>
                <p
                  className={styles.register_button_reset}
                  onClick={() => setRecoverPassword(true)}

                >
                  Забыли пароль?
                  {/* <img src={rostok} className={styles.size} alt="" /> */}
                </p>
                <hr className={styles.hr__line}></hr>
                <div className={styles.helper__title}>или</div>
                <div className={styles.div_social}>
                  <Button className={styles.sign__google__btns} onClick={signIn}>
                    <img style={{ width: "36px" }} src={googleIcon} alt="" />
                  </Button>
                 
             
                </div>
            



              
              </div>

             
              <Notification notify={notify} setNotify={setNotify} />
            </div>
          ) : (
            <div style={{ maxWidth: "470px" }}>

              <RecoverPinForm setRecoverPin={setRecoverPin} />
            </div>
          )
        ) : (
          <div style={{ maxWidth: "470px" }}>
            <RecoverPasswordForm setRecoverPassword={setRecoverPassword} RecoverPin={RecoverPin} />
          </div>
        )
      ) : (
        <div style={{ maxWidth: "470px" }}>
          <RegisterForTest setLoginMail={setLoginMail} RecoverPin={RecoverPin} />
        </div>

      )}
      {userPinCode === null ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  Добро пожаловать!
                </p>
              </>
            }
            modalText={"Придумайте ПИН-код"}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  Закрыть
                </Button>
                <Button
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  className={styles.btn_pin}
                >
                  Сохранить
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={"Введите ПИН-код"}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {" "}
              Закрыть
            </Button>
            <Button onClick={pinLogIn} className={styles.btn_pin}>
              Войти
            </Button>

          </>
          <div className={styles.div_register_button} style={{ marginTop: '5px' }}>
            <p
              className={styles.register_button_reset}
              onClick={() => RecoverPin()}
              style={{ margin: "0px 10px 0px 0" }}
            >
              Забыли пин?
              {/* <img src={rostok} className={styles.size} alt="" /> */}
            </p>
          </div>
        </ModalWindow>
      )}
    </div>
  );
}

export default LoginForm;
